import { createSlice } from '@reduxjs/toolkit';

// Define the initial state
const initialState = {
    paidAmounts: {},
    paymentComments: {},
};

// Create a slice
const paymentSlice = createSlice({
    name: 'payment',
    initialState,
    reducers: {
        setPaidAmount: (state, action) => {
            const { id, amount } = action.payload;
            state.paidAmounts[id] = amount;
        },
        
        setPaymentComment: (state, action) => {
            const { id, comment } = action.payload;
            state.paymentComments[id] = comment;
        },
    },
});

export const { setPaidAmount, setPaymentComment } = paymentSlice.actions;
export default paymentSlice.reducer;
